export const Config = { apiUrl: 'https://api.tal-software.com/api' };
// export const Config = { apiUrl: 'http://testapi.tal-software.com/api' };
// export const Config = { apiUrl: 'http://localhost:5000/api' };